<template>
    <div class="container py-2">
        <div v-for="item in historyOptions.history" :key="item.id" class="row">
            <div class="col-auto text-center flex-column d-none d-sm-flex">
                <div class="row h-50">
                    <div :class="item !== historyOptions.history[0] ? 'col border-right' : 'col'
                        ">
                        &nbsp;
                    </div>
                    <div class="col">&nbsp;</div>
                </div>
                <h5 style="margin-bottom: -3px">
                    <i class="fa fa-dot-circle"></i>
                </h5>
                <div class="row no-gutters h-50">
                    <div class="col border-right">&nbsp;</div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
            <div class="col py-2">
                <div :class="`card ${item.borderColor} shadow`">
                    <div class="card-body">
                        <div class="float-right text-muted">{{ item.dateString }}</div>
                        <div class="card-title text-muted">
                            {{ item.message }} por
                            <span class="badge badge-info">
                                {{ item.userName }}
                            </span>
                        </div>
                        <div class="card-text">
                            {{ item.bodyMessage }} <br />
                            <span v-if="item.actionPerformed === 'REJECT'">Motivo de Rechazo:
                                <strong>{{ item.actionPerformedDescription }}</strong></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Get } from "@/helper/axios";

export default {
    props: ["historyOptions"],
    name: "HistoryModalRequest",
    data() {
        return {
            Get,
            apiUrl: this.$store.getters.apiUrl,
            icon: "",
        };
    },
    computed: {
        history() {
            return this.historyOptions.history;
        },
    },
};
</script>

<style scoped></style>
